export default "/images/8588bec51eccb25f20fa9ef5e8aef451.avif";